import { render, staticRenderFns } from "./ParticipantEditor.vue?vue&type=template&id=f59c44ca&scoped=true&"
import script from "./ParticipantEditor.vue?vue&type=script&lang=js&"
export * from "./ParticipantEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59c44ca",
  null
  
)

export default component.exports